import { enumNumericValues } from '@sonar-software/sonar-ts-lib';
import { FieldUsageId } from '@sonar-software/sonar-core';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import React from 'react';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { OptionFilter } from '@periscopes/general/filters';
function getLabel(value) {
    return value === FieldUsageId.None ? COPY_SPECIFIC.NO_FIELD_USAGE : FieldUsageId[value];
}
const options = enumNumericValues(FieldUsageId).map((value) => ({
    label: getLabel(value),
    value
}));
export const FieldUsageFilter = (props) => {
    const { format, id, label, onChange, value } = props;
    return (React.createElement(FilterComponent, Object.assign({}, props, { tagProps: {
            label,
            value: value === null || value === void 0 ? void 0 : value.map(getLabel).join(', ')
        } }),
        React.createElement(OptionFilter, { className: 'filter', getPopupContainer: getDirectParent, id: getFilterId(id), mode: 'multiple', onChange: (newSelection) => {
                onChange({
                    [id]: {
                        format,
                        value: newSelection
                    }
                });
            }, options: options, placeholder: PLACEHOLDERS_COPY.FILTER_BY(label), showArrow: true, value: value })));
};
